import React from 'react'
import _ from 'lodash'

export function toOptions(items, { getTitle, getValue } = {}) {
  return _.map(items, (item, index) => {
    const value = getValue ? getValue(item, index) : item
    const title = getTitle ? getTitle(item, index) : item

    return { title, value }
  })
}

export function renderOptions(options) {
  return _.map(options, (option, index) => (
    <option key={option.value} value={option.value}>
      {option.title}
    </option>
  ))
}



// WEBPACK FOOTER //
// ./src/modules/options.js